import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import ViewObserver from './ViewObserver';
//https://markmurray.co/blog/view-tracking-with-react/
class ViewTracker extends Component {
    constructor() {
        super(...arguments);
        /**
         * Send the tracking event callback
         * @param  {Boolean} visible - the visibility state of the element
         */
        this.trackEvent = (visible) => {
            this.props.onChange(visible);
            if (visible) {
                this.props.onView(visible);
                // Unobserve the element after firing
                if (this.props.once)
                    this.unobserve();
            }
            else {
                this.props.onHide(visible);
            }
        };
    }
    /**
     * Create the event listener on mount
     */
    componentDidMount() {
        this.observer = ViewObserver.get(this.props.options);
        this.container = findDOMNode(this);
        if (typeof this.container !== 'undefined') {
            // Observe the container and track all child nodes
            this.observer.observe(this.container, this.trackEvent);
        }
    }
    unobserve() {
        if (typeof this.container !== 'undefined' && this.observer) {
            // Remove the observation listener
            this.observer.unobserve(this.container);
        }
        this.observer = null;
    }
    /**
     * Remove the observe listener on unmount
     */
    componentWillUnmount() {
        this.unobserve();
    }
    render() {
        // Use React.Children.only to indicate that their
        // should only be a single child component
        return React.Children.only(this.props.children);
    }
}
ViewTracker.defaultProps = {
    once: true,
    children: null,
    options: null,
    onView() { },
    onHide() { },
    onChange() { },
};
export default ViewTracker;
